import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dcd3d13"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "school-page" }
const _hoisted_2 = { class: "operation-area" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_4 = { class: "table-area" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_11 = { class: "custom-tree-node" }
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tree_select = _resolveComponent("el-tree-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_hasPermi = _resolveDirective("hasPermi")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _ctx.handleAddClick
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_table, {
        data: _ctx.tableData,
        style: {"width":"100%"},
        border: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((props) => [
              (props.row.roomList && props.row.roomList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_el_table, {
                      data: props.row.roomList,
                      border: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "name",
                          label: "教室名称",
                          width: "180"
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "操作",
                          "min-width": "150",
                          fixed: "right",
                          align: "right"
                        }, {
                          default: _withCtx((scope) => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              size: "small",
                              onClick: ($event: any) => (_ctx.handleEditClick(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_el_button, {
                              type: "danger",
                              size: "small",
                              onClick: ($event: any) => (_ctx.handleDeleteClick(scope.row))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_7
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["data"])
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_8, "暂无教室数据"))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "名称"
          }),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: "类型",
            width: "100"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.type === '1' ? '校区' : '教室'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "locationProvince",
            label: "省份"
          }),
          _createVNode(_component_el_table_column, {
            prop: "locationCity",
            label: "城市"
          }),
          _createVNode(_component_el_table_column, {
            prop: "locationCounty",
            label: "区县"
          }),
          _createVNode(_component_el_table_column, {
            prop: "locationDetail",
            label: "详细地址"
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            "min-width": "150",
            fixed: "right",
            align: "right"
          }, {
            default: _withCtx((scope) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                size: "small",
                onClick: ($event: any) => (_ctx.handleEditClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_hasPermi, ['system:schoolSetting:edit']]
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "danger",
                size: "small",
                onClick: ($event: any) => (_ctx.handleDeleteClick(scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_hasPermi, ['system:schoolSetting:delete']]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.dialogTitle,
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      width: "30%",
      onClose: _ctx.resetForm
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.handleConfirm
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          ref: "formRef",
          "label-width": "100px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "类型",
              prop: "type"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formData.type,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.type) = $event)),
                  placeholder: "请选择类型",
                  onChange: _ctx.handleTypeChange
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "校区",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "教室",
                      value: "2"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "onChange"])
              ]),
              _: 1
            }),
            (_ctx.formData.type === '2')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "校区",
                  prop: "pid"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.formData.pid,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.pid) = $event)),
                      placeholder: "请选择校区"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.schoolOptions, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.name,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formData.type === '1')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "地区"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tree_select, {
                      modelValue: _ctx.areaValue,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.areaValue) = $event)),
                      data: _ctx.geoAreaList,
                      style: {"width":"300px"},
                      "node-key": "id",
                      props: {
                label: 'name',
                children: 'child'
              },
                      onChange: _ctx.handleAreaChange,
                      placeholder: "请选择地区"
                    }, {
                      default: _withCtx(({ node }) => [
                        _createElementVNode("span", _hoisted_11, [
                          _createElementVNode("span", null, _toDisplayString(node.label), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "data", "onChange"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.formData.type === '1')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "详细地址",
                  prop: "locationDetail"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.formData.locationDetail,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.locationDetail) = $event)),
                      placeholder: "请输入详细地址"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.name) = $event)),
                  placeholder: "请输入教室/校区名称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onClose"])
  ]))
}